export default "__VITE_ASSET__Ct7Vd$wN__"